Date.prototype.addMinutes = function(minutes) {
  var date = new Date(this.valueOf());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}